import type { ReactNode } from 'react';

import { ErrorIcon } from 'components/atoms/Icons';
import { CaptionStrong } from 'components/atoms/LegacyText';
import { cn } from 'utils/cn';
import Tooltip from '../Tooltip';

export type InputErrorProps = {
  errors?: string[];
  showErrorAsTooltip?: boolean;
  icon?: ReactNode;
};

export const InputError = ({
  errors = [],
  showErrorAsTooltip,
  icon,
}: InputErrorProps) => {
  if (!errors?.length) {
    return null;
  }

  if (showErrorAsTooltip) {
    return (
      <div className="flex">
        <Tooltip
          content={
            <CaptionStrong data-test-id="input-error" role="alert">
              {errors.join(', ')}
            </CaptionStrong>
          }
          placement="top-start"
        >
          <ErrorIcon
            className="cursor-pointer"
            data-test-id="input-error-icon"
            customFill={true}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={cn('flex gap-xs2', icon ? 'items-center' : 'items-start')}>
      {icon && (
        <div className="flex items-center flex-shrink-0 mt-[2px]">{icon}</div>
      )}
      <CaptionStrong
        className={cn('text-error-text-01', icon ? 'mb-0' : 'mb-xs2')}
        data-test-id="input-error"
        role="alert"
      >
        {errors.join(', ')}
      </CaptionStrong>
    </div>
  );
};

export default InputError;
